import { PassTier } from 'data/PassTier'

export const isFreeTier = (p: PassTier) => p.amount === 0
